// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import { createRoot } from 'react-dom/client';
import {
    Alert,
    Chip,
    CircularProgress,
    Divider,
    Tooltip,
    IconButton,
    FormControlLabel,
    Checkbox,
    Autocomplete,
    Paper,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { getDesigner, getProses, getSite } from '../../../../api/helper';
import './detail.scss';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const { showToast, hideToast } = useToast();

    const { id } = useParams();

    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openImageDialog, setOpenImageDialog] = useState(false)
    const [workOrderImage, setWorkOrderImage] = useState<string | null>(null)
    const [imageLoading, setImageLoading] = useState(false)
    const [imageError, setImageError] = useState(false)
    const [openDialogSalesOrder, setOpenDialogSalesOrder] = useState<boolean>(false)
    const [openDialogBom, setOpenDialogBom] = useState<boolean>(false)
    const [openDialogKode, setOpenDialogKode] = useState<boolean>(false)
    const [listSalesOrder, setListSalesOrder] = useState<any[]>([])
    const [listBomVsActual, setListBomVsActual] = useState<any[]>([])
    const [editDetail, setEditDetail] = useState<boolean>(false)
    const [isInternal, setIsInternal] = useState<boolean>(false)
    const [listBom, setListBom] = useState<any[]>([])
    const [jenisOptions, setJenisOptions] = useState<any[]>([])
    const [barangOptions, setBarangOptions] = useState<any[]>([])
    const [valJenisBarang, setValJenisBarang] = useState<any>(null)
    const [valBarang, setValBarang] = useState<any>(null)
    const [isGenerateQuantifier, setIsGenerateQuantifier] = useState<boolean>(false)
    const [tabs, setTabs] = useState<string>("0")
    const [listSite, setListSite] = useState<any[]>([])
    const [listDesigner, setListDesigner] = useState<any[]>([])
    const [listProses, setListProses] = useState<any[]>([])
    const [productionHistory, setProductionHistory] = useState<any[]>([])
    const [productionHistoryLoading, setProductionHistoryLoading] = useState<boolean>(true)
    const [productionHistoryError, setProductionHistoryError] = useState<string>('')
    const [deletingProductionHistoryId, setDeletingProductionHistoryId] = useState<any>(null)

    const [listCopyBOM, setListCopyBOM] = useState<any[]>([])
    const [openDialogListBOM, setOpenDialogListBOM] = useState<boolean>(false)

    useEffect(() => {
        fetchSite()
        fetchDesigner()
        fetchProses()
        getData()
        getDetail()
        getListBom()
        getBomVsActual()
        getProductionHistory()
        fetchCombo('/mm/jenis-barang/list-combo', setJenisOptions)
    }, [])

    const fetchDesigner = async () => {
        const response = await getDesigner(cabang, token);
        setListDesigner(response);
    };

    const fetchProses = async () => {
        const response = await getProses(token);
        setListProses(response);
    };

    const fetchSite = async () => {
        const response = await getSite(cabang, token);
        setListSite(response);
    };

    const fetchCombo = (endpoint: string, setter: (data: any[]) => void) => {
        axios
            .get(apiUrl.apiUrl + endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setter(res.data.data)
            })
    }
    const getListSalesOrder = (productId: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/list-open-sales-order'
        axios
            .get(url, {
                params: { sdproduct_id: productId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSalesOrder(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const renderMaterialCost = (key: string, value: any, row: any) => {
        const notes: string[] = []
        if (value === null || value === undefined) notes.push('Harga belum tersedia; biaya belum masuk total.')
        if ((key === 'harga' || key === 'nilai_bom') && row.bom_estimasi) {
            notes.push(`Estimasi memakai harga setelah WO (${row.tanggal_harga_bom}).`)
        }
        if (key === 'nilai_realisasi' && row.sumber_harga_actual?.includes('Estimasi')) {
            notes.push(row.sumber_harga_actual)
        }
        return <Tooltip title={notes.join(' ')} describeChild>
            <span>{value == null ? '—' : formatRupiah(value)}</span>
        </Tooltip>
    }

    const getBomVsActual = () => {
        const url = apiUrl.apiUrl + '/production/work-order/bom-vs-actual/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBomVsActual(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    // Komponen kecil untuk 1 item informasi
    const InfoItem = ({ label, value }: { label: string; value: string | number }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value || "-"}
            </Typography>
        </Box>
    );

    const rowClickSalesOrder = (e: any) => {
        const data = e.data
        setOpenDialog(false)
        setOpenDialogSalesOrder(true)
        setValue('sdsoDId', data.id)
        setValue('namaCustomerDetail', data.nama_customer)
        setValue('namaProductDetail', data.nama)
        setValue('kodeProductDetail', data.kode)
        setValue('keteranganSoDetail', data.keterangan_so)
        setValue('qtyDetail', data.qty)
        setValue('keteranganDetail', data.keterangan)
        setEditDetail(false)
    }

    const rowClickBOM = (e: any) => {
        const data = e.data

        setOpenDialogListBOM(false)
        handleCopyBOM(data.id)
    }

    const handleCopyBOM = (ids: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/gen-copy-bom/' + id
        axios
            .get(url, {
                params: { wo_order_id: ids },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    getListBom()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/production/work-order/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }
    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/production/work-order/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    // console.log(data)
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('qty', data.qty)
                    setValue('product', data.product)
                    setWorkOrderImage(data.gambar || null)
                    setValue('sdproduct_id', data.sdproduct_id)
                    setValue('barang', data.barang)
                    setValue('mmbarang_id', data.mmbarang_id)
                    setValue('dokumen', data.dokumen)
                    setValue('jenis', data.jenis)
                    setValue('notes', data.notes)
                    setValue('satuan', data.satuan)
                    setValue('tgl', data.tgl)
                    setValue('tgl_deadline', data.tgl_deadline)
                    setValue('wo_proses_id', data.wo_proses_id)
                    setValue('proses', data.proses)
                    setValue('site', data.site)
                    setValue('site_id', data.site_id)
                    setValue('kode', data.kode)
                    setValue('designer', data.designer)
                    setValue('designer_id', data.designer_id)
                    setValue('sdso_id', data.sdso_id)
                    setValue('keterangan', data.keterangan ?? null)
                    getListSalesOrder(data.sdproduct_id)
                    setIsGenerateQuantifier(data.is_generate_quantifier)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getProductionHistory = () => {
        setProductionHistoryLoading(true)
        setProductionHistoryError('')
        const url = apiUrl.apiUrl + '/production/work-order/history-production/' + id
        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    setProductionHistory(Array.isArray(response.data.data?.plans) ? response.data.data.plans : [])
                } else {
                    setProductionHistoryError(response.data.message || 'Riwayat input produksi gagal dimuat.')
                }
            })
            .catch(error => {
                setProductionHistoryError(error?.response?.data?.message || error.message || 'Riwayat input produksi gagal dimuat.')
            })
            .finally(() => setProductionHistoryLoading(false))
    }

    const handleDeleteProductionHistory = async (detail: any) => {
        const confirmation = await Swal.fire({
            title: 'Hapus input produksi?',
            text: `${detail.proses || 'Proses'} oleh ${detail.pic || '-'} dengan qty ${Number(detail.qty || 0).toLocaleString('id-ID')} akan dibatalkan. Dokumen BHP terkait beserta penambahan stoknya ikut dibatalkan, dan progress produksi dihitung ulang.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Ya, hapus',
            cancelButtonText: 'Batal',
        })

        if (!confirmation.isConfirmed) return

        setDeletingProductionHistoryId(detail.id)
        try {
            const response = await axios.delete(
                apiUrl.apiUrl + '/production/work-order/history-production-detail/' + detail.id,
                { headers: { Authorization: `Bearer ${token}` } }
            )
            if (!response.data.success) throw new Error(response.data.message || 'Input produksi gagal dihapus.')
            showToast(response.data.message || 'Input produksi berhasil dihapus.', 'success')
            getProductionHistory()
            getData()
        } catch (error: any) {
            showToast(error?.response?.data?.message || error.message || 'Input produksi gagal dihapus.', 'error')
        } finally {
            setDeletingProductionHistoryId(null)
        }
    }

    const resetDetail = () => {
        setValue('qtyDetail', null)
        setValue('keteranganDetail', null)
        setValue('sdsoDId', null)
        setValue('namaCustomerDetail', null)
        setValue('namaProductDetail', null)
        setValue('keteranganSoDetail', null)
        setValue('kodeProductDetail', null)
        setValue('woOrderDId', null)
        setValue('mmjenis_barang_id', null)
        setValue('mmbarang_id', null)
        setValue('wo_order_bom_id', null)
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        tgl_deadline: any,
        jenis: any,
        qty: any,
        notes: any,
        keterangan: any,
        qtyDetail: any,
        keteranganDetail: any,
        sdsoDId: any,
        namaCustomerDetail: any,
        namaProductDetail: any,
        kodeProductDetail: any,
        keteranganSoDetail: any,
        woOrderDId: any,
        product: any,
        barang: any,
        mmbarang_id: any,
        dokumen: any,
        sdproduct_id: any,
        sdso_id: any,
        satuan: any,
        wo_proses_id: any,
        proses: any,
        mmjenis_barang_id: any,
        wo_order_bom_id: any,
        site: any,
        site_id: any,
        kode: any,
        designer: any,
        designer_id: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        sdproduct_id: null,
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const [materialStock, setMaterialStock] = useState<any>(null)
    const [materialStockLoading, setMaterialStockLoading] = useState(false)
    const [materialStockError, setMaterialStockError] = useState('')
    const selectedMaterial = watch('mmbarang_id')
    const enteredBomQty = watch('qtyDetail')
    const editingBomId = watch('wo_order_bom_id')
    useEffect(() => {
        let active = true
        setMaterialStock(null)
        setMaterialStockError('')
        setMaterialStockLoading(false)
        if (!openDialogBom || !selectedMaterial) return
        setMaterialStockLoading(true)
        axios.get(`${apiUrl.apiUrl}/production/work-order/material-availability/${id}`, {
            params: { mmbarang_id: selectedMaterial },
            headers: { Authorization: `Bearer ${token}` }
        }).then(response => {
            if (!active) return
            if (response.data.success && response.data.data) setMaterialStock(response.data.data)
            else setMaterialStockError('Saldo bahan belum dapat ditampilkan.')
        }).catch(() => {
            if (active) setMaterialStockError('Gagal mengambil saldo bahan. Coba pilih ulang barang.')
        }).finally(() => { if (active) setMaterialStockLoading(false) })
        return () => { active = false }
    }, [openDialogBom, selectedMaterial, id, token])
    const oldBomLine = editDetail ? listBom.find(row => String(row.id) === String(editingBomId)
        && String(row.mmbarang_id) === String(selectedMaterial)) : null
    const previewBom = Math.max(0, Number(materialStock?.bom_total_barang || 0)
        - Number(oldBomLine?.qty_bom || 0) + Number(enteredBomQty || 0))
    const previewRemaining = Math.max(0, previewBom - Number(materialStock?.pemakaian_wo || 0))
    const previewShortage = Math.max(0, previewRemaining - Number(materialStock?.saldo_tersedia || 0))
    const stockNumber = (value: any) => Number(value || 0).toLocaleString('id-ID', { maximumFractionDigits: 3 })

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    resetDetail();
                    setOpenDialogSalesOrder(true);
                    setValue('woOrderDId', row.id);
                    setValue('namaCustomerDetail', row.nama_customer);
                    setValue('namaProductDetail', row.nama_product);
                    setValue('kodeProductDetail', row.kode_product);
                    setValue('keteranganSoDetail', row.keterangan_so);
                    setValue('qtyDetail', row.qty);
                    setValue('keteranganDetail', row.notes);
                    setEditDetail(true);
                }
            },
            {
                title: "Hapus Work Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleAutoCompleteJenisBarang = async (event: SyntheticEvent, newValue: any | null) => {
        let barangList = await getListCombo(newValue?.id);
        setBarangOptions(barangList);
        setValJenisBarang(newValue);
        setValue('mmjenis_barang_id', newValue?.id);
        setValue('mmbarang_id', null);
    }

    const handleAutoCompleteBarang = async (event: SyntheticEvent, newValue: any | null) => {
        setValBarang(newValue);
        setValue('mmbarang_id', newValue?.id);
    }

    const ActionButtonsBom = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    setEditDetail(true)
                    setValue('wo_order_bom_id', row.id)
                    setValue('mmjenis_barang_id', row.jenis_barang_id)
                    setValue('mmbarang_id', row.mmbarang_id)
                    setValue('qtyDetail', row.qty_bom)
                    setValue('keterangan', row.keterangan)
                    setValJenisBarang({ 'id': row.jenis_barang_id, 'nama': row.jenis_barang })
                    setValBarang({ 'id': row.mmbarang_id, 'nama': row.barang })
                    setOpenDialogBom(true)
                }
            },
            {
                title: "Hapus BOM",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/delete-work-order-d/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    getDetail()
                    getData()
                    showToast(response.data.message, 'success');
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };
    const handleDeleteBom = (row: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/delete-bom/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getListBom()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const actionDataBom = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsBom
                    row={row}
                    onDelete={handleDeleteBom}
                />
            ),
        },
    ];

    const getListBom = () => {
        const url = apiUrl.apiUrl + '/production/work-order/list-bom/' + id
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListBom(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getListBomCopy = () => {
        const url = apiUrl.apiUrl + '/production/work-order/list-copy-bom/' + id
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListCopyBOM(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getListCombo = async (jenis: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/list-barang-by-jenis/' + jenis
        try {
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            if (response.data.success) {
                return response.data.data;
            } else {
                showToast(response.data.message, 'error');
                return [];
            }
        } catch (error: any) {
            showToast(error.message, 'error');
            return [];
        }
    }
    const handlePilihBarang = async (row: any) => {
        let option = await getListCombo(row.jenis_barang_id)
        Swal.fire({
            title: 'Pilih Barang',
            html: `<div id="swal-autocomplete"></div>`,
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            didOpen: () => {
                const root = createRoot(document.getElementById('swal-autocomplete')!);
                root.render(
                    <Autocomplete
                        options={option}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                const confirmButton = Swal.getConfirmButton();
                                if (confirmButton) {
                                    confirmButton.addEventListener('click', () => {
                                        const data = {
                                            id: row.id,
                                            mmbarang_id: newValue.id
                                        }

                                        axios.post(apiUrl.apiUrl + '/production/work-order/edit-barang-bom/' + row.id, data, {
                                            headers: { Authorization: `Bearer ${token}` }
                                        })
                                            .then(response => {
                                                if (response.data.success) {
                                                    showToast(response.data.message, 'success');
                                                    getListBom()
                                                } else {
                                                    showToast(response.data.message, 'error');
                                                }
                                            })
                                    })
                                }
                            }
                        }}
                        renderOption={(props: any, option: any) => (
                            <li {...props} key={option.id}>
                                {option.nama}
                            </li>
                        )}
                        getOptionLabel={(option: any) => option.nama}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label='Pilih Barang'
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                );
            }
        })
    }

    const convertComponent = [
        {
            key: 'kekurangan',
            renderCell: (cell: any) => cell.value == null ? '—' : (
                <Tooltip title={`Estimasi kebutuhan seluruh baris bahan ini pada WO. ${cell.data.cakupan_stok || ''}. PR/PO belum dihitung sebagai stok fisik.`}>
                    <span style={{ color: Number(cell.value) > 0 ? '#b45309' : undefined }}>
                        {stockNumber(cell.value)}{Number(cell.value) > 0 ? ' — Cek PR' : ''}
                    </span>
                </Tooltip>
            )
        },
        // {
        //     key: "barang",
        //     renderCell: (row: any) => (
        //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        //             <Typography variant='body2'>
        //                 {row.value || ""}
        //             </Typography>
        //             {row.value == null ? (
        //                 <IconButton
        //                     color="primary"
        //                     size="small"
        //                     onClick={() => { handlePilihBarang(row.data) }}
        //                     sx={{
        //                         backgroundColor: 'primary.main',
        //                         color: 'white',
        //                         '&:hover': {
        //                             backgroundColor: 'primary.dark',
        //                         },
        //                         borderRadius: 1,
        //                         boxShadow: 1,
        //                     }}
        //                 >
        //                     <Icon icon="mdi:plus" />
        //                 </IconButton>
        //             ) : (
        //                 <IconButton color="primary" size="small" onClick={() => {
        //                     handlePilihBarang(row.data)
        //                 }}>
        //                     <Icon icon="mdi:pencil" />
        //                 </IconButton>
        //             )}
        //         </Box>
        //     ),
        // },
        {
            key: "is_kain",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.data.is_kain === 1} readOnly />}
                    />
                );
            },
        },
        {
            key: "is_jasa",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.data.is_jasa === 1} readOnly />}
                    />
                );
            },
        },
    ];

    const formatRupiah = (value) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }).format(value || 0)
    }

    const formatProductionDate = (value: any) => value
        ? new Intl.DateTimeFormat('id-ID', {
            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
        }).format(new Date(String(value).replace(' ', 'T')))
        : '-'

    const productionStatus = (status: string) => {
        if (status === 'selesai') return { label: 'Selesai', color: 'success' as const }
        if (status === 'proses') return { label: 'Diproses', color: 'primary' as const }
        return { label: 'Belum mulai', color: 'default' as const }
    }

    const productionPlanCount = productionHistory.length
    const completedProductionPlanCount = productionHistory.filter((plan: any) => plan.status === 'selesai').length
    const productionInputCount = productionHistory.reduce((total: number, plan: any) => total + Number(plan.jumlah_input || 0), 0)
    const productionOverview = productionPlanCount > 0 && completedProductionPlanCount === productionPlanCount
        ? { label: 'Produksi selesai', color: 'success' as const, icon: 'mdi:check-circle-outline' }
        : productionInputCount > 0
            ? { label: 'Sedang diproses', color: 'primary' as const, icon: 'mdi:cog-sync-outline' }
            : { label: 'Menunggu produksi', color: 'default' as const, icon: 'mdi:clock-outline' }

    const summaryCards: Array<{ label: string; value: string; icon: string; tone: string; meta?: string }> = [
        { label: 'Target produksi', value: `${Number(watch('qty') || 0).toLocaleString('id-ID')} ${watch('satuan') || ''}`, icon: 'mdi:package-variant-closed', tone: 'blue' },
        { label: 'Deadline', value: watch('tgl_deadline') ? new Date(watch('tgl_deadline')).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) : '-', icon: 'mdi:calendar-clock-outline', tone: 'orange' },
        { label: 'Alur proses', value: watch('proses') || '-', icon: 'mdi:source-branch', tone: 'purple' },
        { label: 'Progress plan', value: productionHistoryLoading ? 'Memuat...' : `${completedProductionPlanCount}/${productionPlanCount} selesai`, meta: `${productionInputCount} input produksi`, icon: 'mdi:chart-timeline-variant-shimmer', tone: 'green' },
    ]

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                let url = apiUrl.apiUrl + '/production/work-order/edit-kode-wo/' + id;

                axios.post(url, data, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, 'success');
                            getData();
                        } else {
                            showToast(response.data.message, 'error');
                            setOpenDialogKode(false);
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    });
            }
        })
    }

    return (
        <Grid container className="wo-detail-page">
            <Grid item xl={12} md={12} xs={12}>
                <Button className="wo-back-button" startIcon={<Icon icon='mdi:arrow-left' />} onClick={() => window.history.back()}>Kembali ke Work Order</Button>
                <Box className="wo-detail-content">
                    <Paper className="wo-detail-hero" elevation={0}>
                        <Box className="wo-hero-main">
                            <Box className="wo-hero-icon"><Icon icon="mdi:clipboard-text-outline" /></Box>
                            <Box className="wo-hero-copy">
                                <Typography variant="overline">DETAIL WORK ORDER</Typography>
                                <Typography variant="h4">{watch('kode') || id}</Typography>
                                <Typography variant="body2">{watch('product') || watch('barang') || 'Produk belum tersedia'} • Dokumen #{id}</Typography>
                            </Box>
                        </Box>
                        <Box className="wo-hero-status">
                            <Button variant='contained' startIcon={<Icon icon='mdi:image-outline' />} onClick={() => {
                                setImageError(false)
                                setImageLoading(Boolean(workOrderImage))
                                setOpenImageDialog(true)
                            }} sx={{
                                color: '#123a6f',
                                backgroundColor: '#fff',
                                fontWeight: 800,
                                px: 2.5,
                                py: 1,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                                '&:hover': { backgroundColor: '#e3f2fd' },
                                '&.Mui-focusVisible': { outline: '3px solid #ffca28', outlineOffset: 3 }
                            }}>
                                Lihat Gambar
                            </Button>
                            <Chip icon={<Icon icon={productionOverview.icon} />} color={productionOverview.color} label={productionOverview.label} />
                            <Box className="wo-hero-tags">
                                <Chip size="small" variant="outlined" label={watch('site') || 'Site belum dipilih'} />
                                <Chip size="small" variant="outlined" label={watch('jenis') || 'Jenis belum tersedia'} />
                            </Box>
                        </Box>
                    </Paper>

                    <Box className="wo-summary-grid">
                        {summaryCards.map(card => <Paper key={card.label} className={`wo-summary-card tone-${card.tone}`} elevation={0}>
                            <Box className="wo-summary-icon"><Icon icon={card.icon} /></Box>
                            <Box minWidth={0}>
                                <Typography variant="caption">{card.label}</Typography>
                                <Typography className="wo-summary-value">{card.value}</Typography>
                                {card.meta && <Typography variant="caption" className="wo-summary-meta">{card.meta}</Typography>}
                            </Box>
                        </Paper>)}
                    </Box>
                    {/* <form>
                        <Grid container spacing={2} sx={{ ml: 3 }}>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Document" value={watch("dokumen")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Jenis Product" value={watch("jenis")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Product" value={watch("product")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Barang" value={watch("barang")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty" value={watch("qty") + " " + watch("satuan")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem
                                    label="Tanggal"
                                    value={
                                        watch("tgl")
                                            ? new Date(watch("tgl")).toLocaleDateString("id-ID", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            })
                                            : "-"
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem
                                    label="Tanggal Deadline"
                                    value={
                                        watch("tgl_deadline")
                                            ? new Date(watch("tgl_deadline")).toLocaleDateString("id-ID", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            })
                                            : "-"
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Site" value={watch("site")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mb: 2 }}>
                                    <InfoItem label="Kode" value={watch("kode")} />
                                    <IconButton color="primary" size="small" onClick={() => {
                                        setOpenDialogKode(true)
                                    }}>
                                        <Icon icon="mdi:pencil" />
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Designer" value={watch("designer")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Proses" value={watch("proses")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="ID SO" value={watch("sdso_id")} />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <InfoItem label="Keterangan" value={watch("notes")} />
                            </Grid>
                        </Grid>
                    </form> */}
                    <Paper className="wo-detail-section wo-information-section" elevation={0}>
                        <Box className="wo-section-heading">
                            <Box className="wo-section-heading-icon"><Icon icon="mdi:file-document-edit-outline" /></Box>
                            <Box><Typography variant="h6">Informasi Work Order</Typography><Typography variant="body2">Informasi produk dan pengaturan utama dokumen produksi.</Typography></Box>
                        </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2.5}>
                            <Grid item xs={12}><Box className="wo-form-subheading"><Icon icon="mdi:information-outline" /><Box><Typography fontWeight={750}>Ringkasan dokumen</Typography><Typography variant="caption">Data referensi dari sumber Work Order.</Typography></Box></Box></Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='dokumen'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Dokumen'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.dokumen)}
                                                inputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.dokumen && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Dokumen harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Jenis Product'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.jenis)}
                                                inputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.jenis && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Jenis harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='product'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Product'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.product)}
                                                inputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.product && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Product harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='barang'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Barang'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.barang)}
                                                inputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.barang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Barang harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        value={watch('qty') && watch('satuan') ? watch('qty') + ' ' + watch('satuan') : ''}
                                        label='Quantity'
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_deadline'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={
                                                    value
                                                        ? new Date(value).toLocaleDateString("id-ID", {
                                                            weekday: "long",
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "numeric",
                                                        })
                                                        : "-"
                                                }
                                                label='Tanggal Deadline'
                                                onChange={onChange}
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}><Box className="wo-form-subheading wo-form-subheading-editable"><Icon icon="mdi:tune-variant" /><Box><Typography fontWeight={750}>Pengaturan produksi</Typography><Typography variant="caption">Bagian berikut dapat disesuaikan lalu disimpan.</Typography></Box></Box></Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Site</InputLabel>
                                    <Controller
                                        name='site_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Site'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.site_id)}
                                            >
                                                {listSite.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.site_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.kode)}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Kode harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Designer</InputLabel>
                                    <Controller
                                        name='designer_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Designer'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.designer_id)}
                                            >
                                                {listDesigner.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.designer_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Proses</InputLabel>
                                    <Controller
                                        name='wo_proses_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Proses'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.wo_proses_id)}
                                            >
                                                {listProses.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.wo_proses_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sdso_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='ID SO'
                                                onChange={onChange}
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box className="wo-form-actions">
                                    <Typography variant="caption" color="text.secondary">Pastikan site, designer, dan proses sudah sesuai sebelum menyimpan.</Typography>
                                    <Button variant='contained' type='submit' size="large" startIcon={<Icon icon="mdi:content-save-outline" />}>Simpan perubahan</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    </Paper>
                    <Paper className="wo-detail-section wo-items-section" elevation={0}>
                        <Box className="wo-section-heading wo-section-heading-actions">
                            <Box className="wo-section-title-group"><Box className="wo-section-heading-icon"><Icon icon="mdi:format-list-bulleted-square" /></Box><Box><Typography variant="h6">Item Work Order</Typography><Typography variant="body2">{listDetail.length} item terhubung dengan Work Order ini.</Typography></Box></Box>
                            <Box className="wo-section-actions">
                            <Button variant="outlined" color="primary" startIcon={<Icon icon="mdi:cart-arrow-down" />}
                                onClick={() => {
                                    resetDetail()
                                    setEditDetail(false)
                                    setOpenDialog(true)
                                    setIsInternal(false)
                                }}>
                                Tambah Sales Order
                            </Button>
                            <Button variant="contained" color="info" startIcon={<Icon icon="mdi:plus-box-outline" />}
                                onClick={() => {
                                    resetDetail()
                                    setEditDetail(false)
                                    setOpenDialogSalesOrder(true)
                                    setIsInternal(true)
                                }}>
                                Tambah Internal Order
                            </Button>
                            </Box>
                        </Box>
                        <Box className="wo-datagrid-wrap">
                            <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                        </Box>
                    </Paper>
                    <Paper className="wo-detail-section wo-tabs-section" elevation={0}>
                    <TabContext value={tabs}>
                        <TabList
                            className="wo-detail-tabs"
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' icon={<Icon icon="mdi:shape-outline" />} iconPosition="start" label='Quantifier' />
                            <Tab value='1' icon={<Icon icon="mdi:scale-balance" />} iconPosition="start" label='BOM Vs Actual' />
                            <Tab value='2' icon={<Icon icon="mdi:cash-multiple" />} iconPosition="start" label='Usage Biaya' />
                            <Tab value='3' icon={<Icon icon="mdi:history" />} iconPosition="start" label='History Input Produksi' />
                        </TabList>
                        <TabPanel value='0' className="wo-tab-panel">
                            {!isGenerateQuantifier ? (
                                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', mb: 4 }}>
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<Icon icon="mdi:auto-fix" />}
                                        onClick={() => {

                                            Swal.fire({
                                                title: 'Now loading',
                                                allowEscapeKey: false,
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    Swal.showLoading()
                                                }
                                            })

                                            const url = apiUrl.apiUrl + '/production/work-order/generate-quantifier/' + id
                                            axios
                                                .post(url, {}, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        // showToast(response.data.message, 'success');

                                                        Swal.close()

                                                        location.reload();
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                })


                                        }}
                                    >
                                        GENERATE QUANTIFIER
                                    </Button>
                                </Box>
                            ) :
                                <Box sx={{ mt: 4 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 2 }}>
                                        <Button
                                            variant="contained"
                                            color="info"
                                            startIcon={<Icon icon="mdi:auto-fix" />}
                                            onClick={() => {
                                                Swal.fire({
                                                    title: 'Now loading',
                                                    allowEscapeKey: false,
                                                    allowOutsideClick: false,
                                                    didOpen: () => {
                                                        Swal.showLoading()
                                                    }
                                                })

                                                const url = apiUrl.apiUrl + '/production/work-order/generate-quantifier/' + id
                                                axios
                                                    .post(url, {}, {
                                                        headers: { Authorization: `Bearer ${token}` }
                                                    })
                                                    .then(response => {
                                                        if (response.data.success) {
                                                            // showToast(response.data.message, 'success');

                                                            Swal.close()

                                                            location.reload();
                                                        } else {
                                                            showToast(response.data.message, 'error');
                                                        }
                                                    })
                                                    .catch(error => {
                                                        showToast(error.message, 'error');
                                                    })


                                            }}
                                        >
                                            GENERATE ULANG QUANTIFIER
                                        </Button>
                                        <Box>
                                            {listBom.length > 0 ? ('') : (
                                                <Button variant="contained" color="warning" sx={{ mr: 1 }}
                                                    onClick={() => {
                                                        getListBomCopy()
                                                        setOpenDialogListBOM(true)
                                                    }}>
                                                    Copy BOM
                                                </Button>
                                            )}
                                            <Button variant="contained" color="warning"
                                                onClick={() => {
                                                    resetDetail()
                                                    setEditDetail(false)
                                                    setOpenDialogBom(true)
                                                }}>
                                                Tambah BOM Item
                                            </Button>
                                        </Box>

                                    </Box>
                                    <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                                        LIST BOM WORK ORDER
                                    </Typography>
                                    <Box sx={{ overflowX: 'auto' }}>
                                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                                            Saldo bahan baku saat ini, dikurangi sisa kebutuhan WO aktif lain. Kebutuhan dan kekurangan dihitung per bahan dalam WO (baris bahan yang sama tidak dijumlah ulang). PR/PO outstanding belum menjadi stok fisik.
                                        </Typography>
                                        {listBom.some(row => !Object.prototype.hasOwnProperty.call(row, 'saldo_tersedia')) && (
                                            <Alert severity="warning" sx={{ mb: 1 }}>Data saldo bahan belum tersedia dari server. Kolom stok belum dapat dihitung.</Alert>
                                        )}
                                        <MsiDatagrid key={1} array={listBom} actions={actionDataBom}
                                            columnOrder={['barang', 'qty_bom', 'saldo_tersedia', 'kekurangan', 'satuan_stok', 'qty_realisasi', 'stok_fisik', 'kebutuhan_wo_lain', 'sisa_kebutuhan', 'pr_outstanding', 'po_outstanding']}
                                            columnCaptions={{ saldo_tersedia: 'Saldo Open Bahan Baku', kekurangan: 'Kekurangan / Cek PR', kebutuhan_wo_lain: 'Kebutuhan WO Lain', satuan_stok: 'Satuan Stok', po_outstanding: 'PO Belum Datang', pr_outstanding: 'PR Outstanding' }}
                                            customRender={[
                                                ...['saldo_tersedia', 'kekurangan', 'stok_fisik', 'kebutuhan_wo_lain', 'sisa_kebutuhan', 'pr_outstanding', 'po_outstanding'].map(key => ({
                                                    key,
                                                    renderCell: (cell: any) => cell.value == null
                                                        ? <span>{Object.prototype.hasOwnProperty.call(cell.data, key) ? '—' : 'Belum tersedia'}</span>
                                                        : <Tooltip title={cell.data.cakupan_stok || 'Saldo bahan baku'}>
                                                            <span style={{ color: key === 'kekurangan' && Number(cell.value) > 0 ? '#b45309' : undefined }}>
                                                                {stockNumber(cell.value)}{key === 'kekurangan' && Number(cell.value) > 0 ? ' — Cek PR' : ''}
                                                            </span>
                                                        </Tooltip>
                                                })),
                                                ...convertComponent
                                            ]}
                                            convertNumeric={['stok_fisik', 'kebutuhan_wo_lain', 'saldo_tersedia', 'sisa_kebutuhan', 'pr_outstanding', 'po_outstanding']}
                                            hiddenColumns={['is_jasa', 'is_aktif', 'jenis_barang_id', 'mmbarang_id', 'cakupan_stok']} />
                                    </Box>
                                </Box>
                            }
                        </TabPanel>
                        <TabPanel value='1' className="wo-tab-panel">
                            {/* ===== SUMMARY ===== */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Paper elevation={2} sx={{ p: 2, minWidth: 150 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            Total BOM
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].total_bom
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={2} sx={{ p: 2, minWidth: 150 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            Total Realisasi
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].total_realisasi
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>

                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 2,
                                            minWidth: 150,
                                            bgcolor: listBomVsActual && listBomVsActual.length > 0 && listBomVsActual[0].sisa < 0
                                                ? 'error.lighter'
                                                : 'success.lighter'
                                        }}
                                    >
                                        <Typography variant="caption" color="text.secondary">
                                            Sisa
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {listBomVsActual.some(row => row.biaya_belum_lengkap) ? '—' : formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].sisa
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>
                                </Box>
                            </Box>

                            {/* ===== DATAGRID ===== */}
                            <MsiDatagrid
                                key={1}
                                array={listBomVsActual.map(row => ({
                                    nama_barang: row.nama_barang,
                                    qty_bom: row.qty_bom,
                                    qty_realisasi: row.qty_realisasi,
                                    satuan: row.satuan,
                                    harga: row.harga_bom,
                                    nilai_bom: row.nilai_bom,
                                    nilai_realisasi: row.nilai_realisasi,
                                    ...row
                                }))}
                                convertNumeric={['qty_bom', 'qty_realisasi']}
                                convertRupiah={['harga', 'nilai_bom', 'nilai_realisasi']}
                                customRender={['harga', 'nilai_bom', 'nilai_realisasi'].map(key => ({
                                    key,
                                    renderCell: ({ value, data }: any) => renderMaterialCost(key, value, data)
                                }))}
                                hiddenColumns={['barang_id', 'id', 'total_realisasi', 'total_bom', 'sisa', 'bom_estimasi', 'biaya_belum_lengkap', 'harga_bom', 'harga_actual', 'tanggal_harga_bom', 'sumber_harga_bom', 'sumber_harga_actual']}
                            />

                        </TabPanel>
                        <TabPanel value='2' className="wo-tab-panel">
                            <Box sx={{ mt: 4 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
                                    <Box>
                                        <Button variant="contained" color="warning"
                                            onClick={() => {
                                                resetDetail()
                                                setEditDetail(false)
                                                setOpenDialogBom(true)
                                            }}>
                                            Tambah Biaya
                                        </Button>
                                    </Box>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                                    LIST BIAYA WO
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listBom} actions={actionDataBom} customRender={convertComponent} hiddenColumns={['is_jasa', 'is_aktif', 'jenis_barang_id', 'mmbarang_id']} />
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value='3' className="wo-tab-panel">
                            <Box sx={{ mt: 1 }}>
                                <Typography variant="h6" fontWeight={700}>History Input Produksi</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                    Daftar Work Order Plan dan rincian input produksi. Data yang sudah masuk pencairan upah tidak dapat dihapus.
                                </Typography>

                                {productionHistoryError && <Alert severity="error" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={getProductionHistory}>Coba lagi</Button>}>{productionHistoryError}</Alert>}
                                {productionHistoryLoading ? <Box sx={{ py: 6, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : productionHistory.map((plan: any) => {
                                    const status = productionStatus(plan.status)
                                    return <Paper key={plan.wo_plan_id} variant="outlined" sx={{ mb: 2, overflow: 'hidden', borderRadius: 2 }}>
                                        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', bgcolor: 'action.hover' }}>
                                            <Chip size="small" color="primary" variant="outlined" label={`Proses ${plan.urutan}`} />
                                            <Box sx={{ flex: 1, minWidth: 180 }}>
                                                <Typography fontWeight={750}>{plan.nama_proses}</Typography>
                                                <Typography variant="caption" color="text.secondary">Plan ID {plan.wo_plan_id} • {plan.jumlah_input} input</Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography fontWeight={700}>{Number(plan.qty_hasil || 0).toLocaleString('id-ID')} / {Number(plan.qty_target || 0).toLocaleString('id-ID')}</Typography>
                                                <Typography variant="caption" color="text.secondary">Hasil / target</Typography>
                                            </Box>
                                            <Chip size="small" color={status.color} label={status.label} />
                                        </Box>

                                        {plan.details?.length ? <Box sx={{ overflowX: 'auto' }}>
                                            <Box component="table" sx={{ width: '100%', minWidth: 900, borderCollapse: 'collapse', '& th': { textAlign: 'left', px: 2, py: 1.2, fontSize: 12, color: 'text.secondary', bgcolor: 'background.paper' }, '& td': { px: 2, py: 1.4, borderTop: 1, borderColor: 'divider', verticalAlign: 'top' } }}>
                                                <thead><tr><th>Selesai</th><th>PIC</th><th>Qty</th><th>Proses</th><th>Stitch</th><th>Keterangan</th><th>Aksi</th></tr></thead>
                                                <tbody>{plan.details.map((detail: any) => <tr key={detail.id}>
                                                    <td><Typography variant="body2">{formatProductionDate(detail.tgl_selesai || detail.created_at)}</Typography><Typography variant="caption" color="text.secondary">ID {detail.id}</Typography></td>
                                                    <td><Typography variant="body2" fontWeight={650}>{detail.pic || '-'}</Typography>{detail.checker && <Typography variant="caption" color="text.secondary">Checker: {detail.checker}</Typography>}</td>
                                                    <td><Typography fontWeight={750}>{Number(detail.qty || 0).toLocaleString('id-ID')}</Typography></td>
                                                    <td><Typography variant="body2">{detail.proses || plan.nama_proses}</Typography>{detail.sub_proses && <Typography variant="caption" color="text.secondary">{detail.sub_proses}</Typography>}</td>
                                                    <td>{detail.stitch != null ? Number(detail.stitch).toLocaleString('id-ID') : '-'}</td>
                                                    <td>{detail.keterangan || '-'}</td>
                                                    <td><Tooltip title={detail.can_delete ? 'Hapus input produksi' : 'Sudah masuk pencairan upah'}><span><IconButton size="small" color="error" disabled={!detail.can_delete || deletingProductionHistoryId === detail.id} onClick={() => handleDeleteProductionHistory(detail)}>{deletingProductionHistoryId === detail.id ? <CircularProgress size={18} /> : <Icon icon="mdi:delete-outline" />}</IconButton></span></Tooltip></td>
                                                </tr>)}</tbody>
                                            </Box>
                                        </Box> : <Box sx={{ p: 2.5, color: 'text.secondary' }}><Typography variant="body2">Belum ada input produksi pada proses ini.</Typography></Box>}
                                    </Paper>
                                })}

                                {!productionHistoryLoading && !productionHistoryError && productionHistory.length === 0 && <Paper variant="outlined" sx={{ py: 6, textAlign: 'center', color: 'text.secondary' }}><Icon icon="mdi:history" fontSize={42} /><Typography>Belum ada Work Order Plan.</Typography></Paper>}
                            </Box>
                        </TabPanel>
                    </TabContext>
                    </Paper>
                </Box>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <MsiDatagrid array={listSalesOrder} rowClick={rowClickSalesOrder} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogSalesOrder}
                onClose={() => setOpenDialogSalesOrder(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/production/work-order/edit-sales-order/' + data.woOrderDId;
                    } else {
                        url = apiUrl.apiUrl + '/production/work-order/save-sales-order/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.woOrderDId : data.sdsoDId,
                        qty: data.qtyDetail,
                        notes: data.keteranganDetail,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, "success")
                                setOpenDialogSalesOrder(false);
                                getListSalesOrder(getValues('jenis')); // Refresh the sales order list
                                getDetail(); // Refresh the detail list
                                getData(); // Refresh the main data
                            } else {
                                showToast(response.data.message, "error")
                                setOpenDialogSalesOrder(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, "error")
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Sales Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    {editDetail ? <Controller
                                        name='woOrderDId'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='ID Detail'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    /> :
                                        !isInternal ?
                                            <Controller
                                                name='sdsoDId'
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        value={value}
                                                        label='ID SO Detail'
                                                        type='number'
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={onChange}
                                                        InputProps={{ readOnly: true }} // Make the input read-only
                                                    />
                                                )}
                                            />
                                            : null
                                    }
                                </FormControl>
                            </Grid>
                            {
                                !isInternal ?
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='namaCustomerDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Nama Customer'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='namaProductDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Nama Product'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='kodeProductDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Kode Product'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='keteranganSoDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Keterangan SO'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                    :
                                    null
                            }

                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keteranganDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogSalesOrder(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogBom}
                onClose={() => setOpenDialogBom(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/production/work-order/save-edit-bom/' + data.wo_order_bom_id;
                    } else {
                        url = apiUrl.apiUrl + '/production/work-order/save-bom/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.wo_order_bom_id : id,
                        jenis_barang_id: data.mmjenis_barang_id,
                        mmbarang_id: data.mmbarang_id,
                        qty: data.qtyDetail,
                        keterangan: data.keterangan
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogBom(false);
                                getListBom();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogBom(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Work Order BOM
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        {materialStockLoading && <Typography sx={{ mb: 2 }}>Memuat saldo bahan…</Typography>}
                        {materialStockError && <Alert severity="warning" sx={{ mb: 2 }}>{materialStockError}</Alert>}
                        {materialStock && (materialStock.cek_stok ? (
                            <Alert severity={previewShortage > 0 ? 'warning' : 'info'} sx={{ mb: 2 }}>
                                <Typography variant="body2">Stok fisik: {stockNumber(materialStock.stok_fisik)} {materialStock.satuan_stok} · Kebutuhan WO lain: {stockNumber(materialStock.kebutuhan_wo_lain)}</Typography>
                                <Typography variant="body2">Saldo tersedia: {stockNumber(materialStock.saldo_tersedia)} · Sisa kebutuhan WO ini setelah disimpan: {stockNumber(previewRemaining)}</Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    {previewShortage > 0 ? `Kurang ${stockNumber(previewShortage)} ${materialStock.satuan_stok} — cek PR/PO sebelum membuat PR baru.` : 'Saldo cukup untuk sisa kebutuhan WO ini.'}
                                </Typography>
                                <Typography variant="body2">PR outstanding: {stockNumber(materialStock.pr_outstanding)} · PO belum datang: {stockNumber(materialStock.po_outstanding)}</Typography>
                                <Typography variant="caption">{materialStock.cakupan_stok}. Semua qty dalam {materialStock.satuan_stok}. Estimasi, bukan reservasi stok. BOM tetap bisa disimpan.</Typography>
                            </Alert>
                        ) : <Alert severity="info" sx={{ mb: 2 }}>Barang ini tidak menggunakan pencatatan stok.</Alert>)}
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valJenisBarang}
                                        options={jenisOptions}
                                        id='mmjenis_barang_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleAutoCompleteJenisBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={(option: any) => option.nama}
                                        renderInput={(params: any) => (
                                            <TextField
                                                {...params}
                                                label='Jenis Barang'
                                                required
                                                error={Boolean(errors.mmjenis_barang_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valBarang}
                                        options={barangOptions}
                                        id='mmbarang_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleAutoCompleteBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={(option: any) => option.nama}
                                        renderInput={(params: any) => (
                                            <TextField
                                                {...params}
                                                label='Barang'
                                                required
                                                error={Boolean(errors.mmbarang_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                type='text'
                                                multiline
                                                rows={2}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.keterangan)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogBom(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogKode}
                onClose={() => setOpenDialogKode(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/production/work-order/edit-kode-wo/' + id;

                    axios.post(url, {
                        kode: data.kode
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogKode(false);
                                getData();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogKode(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Edit Kode Work Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.kode)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogKode(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialogListBOM}
                onClose={() => setOpenDialogListBOM(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List BOM
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listCopyBOM} rowClick={rowClickBOM} hiddenColumns={['is_produksi']} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogListBOM(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openImageDialog} onClose={() => setOpenImageDialog(false)} fullWidth maxWidth='md' aria-labelledby='wo-image-title'>
                <DialogTitle id='wo-image-title' sx={{ pr: 7 }}>
                    Gambar Work Order — {watch('kode') || id}
                    <IconButton aria-label='Tutup gambar' onClick={() => setOpenImageDialog(false)} sx={{ position: 'absolute', right: 12, top: 12 }}>
                        <Icon icon='mdi:close' />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography color='text.secondary' sx={{ mb: 2 }}>{watch('product') || watch('barang')}</Typography>
                    {!workOrderImage ? <Alert severity='info'>Gambar produk untuk work order ini belum tersedia.</Alert> : imageError ? (
                        <Alert severity='warning'>Gambar gagal dimuat. Periksa koneksi atau ketersediaan file gambar produk.</Alert>
                    ) : (
                        <Box sx={{ textAlign: 'center', minHeight: 120 }}>
                            {imageLoading && <CircularProgress aria-label='Memuat gambar work order' />}
                            <Box component='img' src={workOrderImage} alt={`Gambar ${watch('product') || watch('kode') || id}`}
                                onLoad={() => setImageLoading(false)}
                                onError={() => { setImageLoading(false); setImageError(true) }}
                                sx={{ display: imageLoading ? 'none' : 'block', width: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: 2 }} />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions><Button onClick={() => setOpenImageDialog(false)}>Tutup</Button></DialogActions>
            </Dialog>
        </Grid >
    )
}
